import { initializeApp, getApps } from "firebase/app";
import { getDatabase, ref, get, set } from "firebase/database";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut as firebaseSignOut,
  onAuthStateChanged,
} from "firebase/auth";

const firebaseConfig = {
  apiKey:            "AIzaSyDidoMevjtywGC8yKaI2wktSyFVGRGx49I",
  authDomain:        "hamster-gambler.firebaseapp.com",
  databaseURL:       "https://hamster-gambler-default-rtdb.firebaseio.com",
  projectId:         "hamster-gambler",
  storageBucket:     "hamster-gambler.firebasestorage.app",
  messagingSenderId: "306162272824",
  appId:             "1:306162272824:web:f431b615629677da2774cd",
};

const app      = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const db       = getDatabase(app);
const auth     = getAuth(app);
const provider = new GoogleAuthProvider();

// ─── AUTH EXPORTS ─────────────────────────────────────────────
export { auth, onAuthStateChanged };

export async function signInWithGoogle() {
  try {
    const result = await signInWithPopup(auth, provider);
    return result.user;
  } catch (e) {
    console.error("signInWithGoogle error:", e);
    return null;
  }
}

export async function signOut() {
  try {
    await firebaseSignOut(auth);
  } catch (e) {
    console.error("signOut error:", e);
  }
}

// ─── PUBLIC DB HELPERS (leaderboard / battle — unchanged) ─────
export async function fbGet(path) {
  try {
    const snapshot = await get(ref(db, path));
    return snapshot.exists() ? snapshot.val() : null;
  } catch (e) {
    console.error("fbGet error:", e);
    return null;
  }
}

export async function fbSet(path, value) {
  try {
    await set(ref(db, path), value);
  } catch (e) {
    console.error("fbSet error:", e);
  }
}

export async function fbGetAll(path) {
  try {
    const snapshot = await get(ref(db, path));
    return snapshot.exists() ? snapshot.val() : {};
  } catch (e) {
    console.error("fbGetAll error:", e);
    return {};
  }
}

// ─── USER-SCOPED DB HELPERS (save data) ───────────────────────
// Writes to users/{uid}/{path} — only readable/writable by that user
export async function fbUserGet(uid, path) {
  try {
    const snapshot = await get(ref(db, `users/${uid}/${path}`));
    return snapshot.exists() ? snapshot.val() : null;
  } catch (e) {
    console.error("fbUserGet error:", e);
    return null;
  }
}

export async function fbUserSet(uid, path, value) {
  try {
    await set(ref(db, `users/${uid}/${path}`), value);
  } catch (e) {
    console.error("fbUserSet error:", e);
  }
}